/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    string, shape, arrayOf, bool,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';

const useStyles = makeStyles((theme) => ({
    promoContainer: {
        margin: '0.625rem 0px',
        borderRadius: '5px',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.45)',
    },
    promoMessage: {
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '0.875rem',
        lineHeight: '20px',
        textAlign: 'center',
        letterSpacing: '0.01em',
        color: theme.palette.cms?.black || '#000',
        padding: '1.125rem 1.25rem',
        '@media screen and (max-width: 1280px) and (min-width: 1026px)': {
            padding: '1.125rem 0.15rem',
        },
        '& p': {
            margin: '0px',
        },
        '& a': {
            textDecoration: 'underline',
            color: theme.palette.cms?.black || '#000',
            textUnderlineOffset: '3px',
            textDecorationThickness: '1px',
        },
        [theme.breakpoints.down(600)]: {
            padding: '0.75rem 1.75rem',
            '& span': {
                display: 'block',
            },
        },
    },
    plaRedesignPromoContainer: {
        '& $promoMessage': {
            textAlign: 'left',
            lineHeight: '19px',
            background: '#F4F2F7',
            marginTop: '16px',
            padding: '12px',
            borderRadius: '8px',
            '& strong': {
                display: 'inline-flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                width: '100%',
                '@media screen and (max-width: 600px)': {
                    display: 'block',
                    textAlign: 'center',
                },
            },
            '@media screen and (max-width: 600px)': {
                margin: '16px 16px 0px',
            },
            '& a': {
                marginLeft: '5px',
                whiteSpace: 'nowrap',
                '@media screen and (max-width: 600px)': {
                    whiteSpace: 'pre-wrap',
                },
            },
        },
    },

}));
const PromoMessageUI = ({
    productBaseContent, content = {}, presentationFamily, isPromoRestricted, isPlaRedesignEnabled,
}) => {
    if (presentationFamily === 'food' || !isPromoRestricted) return '';
    const classes = useStyles();

    // Default message if promo restriction message is not coming from CMS
    const defaultPromoMessage = 'Promotion Codes are not accepted on this item.<span> [Click here][1] for promo eligible gifts.</span>\n\n\n  [1]: https://www.1800flower-usa.com/Flowers-Gifts-10317';
    // Get promo restriction message from content or productBaseContent
    const contentPromoMessage = content?.entries?.[0]?.promo_restriction?.promo_restriction_message || '';
    const productPromoMessage = productBaseContent?.entries?.[0]?.promo_restriction?.promo_restriction_message || '';
    const promoMessage = contentPromoMessage || productPromoMessage || defaultPromoMessage;

    return (
        <div className={isPlaRedesignEnabled ? classes.plaRedesignPromoContainer : classes.promoContainer}>
            <div className={classes.promoMessage}>
                <ReactMarkdown
                    source={promoMessage}
                    escapeHtml={false}
                />
            </div>
        </div>
    );
};

PromoMessageUI.propTypes = {
    isPromoRestricted: bool.isRequired,
    productBaseContent: shape({
        entries: arrayOf(shape({
            promo_restriction: shape({
                promo_restriction_message: string,
            }),
            additional_information: arrayOf(shape({
                description_contents_heading: {
                    content_heading: string,
                },
            })),
        })),
    }).isRequired,
    content: shape({
        entries: arrayOf(shape({
            promo_restriction: shape({
                promo_restriction_message: string,
            }),
        })),
    }).isRequired,
    presentationFamily: string.isRequired,
    isPlaRedesignEnabled: bool.isRequired,
};

export default PromoMessageUI;
